exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-sticky {\r\n    position: relative\r\n}\r\n\r\n.row-sticky th {\r\n    position: sticky;\r\n    top: 9%;\r\n    z-index: 1;\r\n    background-color: whitesmoke;\r\n    outline: 1px solid #dbdbdb;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/app/components/cases-management/template-form/template-form.component.css
// module id = 601
// module chunks = 0